import NotificationsLink from './NotificationsLink';
import Searchbar from './Searchbar';
import UserLink from './UserLink';

import './DashboardHeader.scss';

const DashboardHeader = () => {
	return (
		<div className='dashboard-header-container'>
			<Searchbar />
			<NotificationsLink />
			<UserLink />
		</div>
	);
};

export default DashboardHeader;
